import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import ImageLightBox from "../../common/imagelightbox";

import { stypes } from "../../common/common";
import { IcPhotos } from "../../common/svg";

import cover_default from "../../../static/images/cover_default.png";

const CarDetailCover = (props) => {
	const [covers, setCovers] = useState([]);
	const [lightBox, setLightBox] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);

	const { info, stype } = props;
	const { photos, name } = info;
	const isSD = stype === stypes.SD;

	useEffect(() => {
		if (photos) {
			if (covers.length < 4 && photos.length < 4) {
				setCovers([...photos, photos[0]]);
			} else {
				setCovers(photos);
			}
		} else {
			setCovers([
				{
					id: 0,
					thumbUrl: cover_default,
					fullUrl: cover_default,
				},
			]);
		}
	}, []);

	const showLightBox = (i) => {
		setLightBox(true);
		setPhotoIndex(i);
	};

	const hideLightBox = () => {
		setLightBox(false);
	};

	return (
		<div className="cover-car">
			<div className="m-container">
				<div className="cover-car-container">
					<div className="main-img">
						<div className="cover-car-item" onClick={() => showLightBox(0)}>
							<img
								loading="lazy"
								src={covers[0]?.fullUrl}
								alt={`${isSD ? `Cho thuê xe tự lái ${name}` : `Cho thuê xe du lịch ${name}`}`}
							/>
						</div>
					</div>
					<div className="sub-img">
						{covers.flatMap((cover, i) =>
							i > 0 && i < 4 ? (
								<div key={i} className="cover-car-item" onClick={() => showLightBox(i)}>
									<img
										loading="lazy"
										src={cover.fullUrl}
										alt={`${isSD ? `Cho thuê xe tự lái ${name}` : `Cho thuê xe du lịch ${name}`}`}
									/>
								</div>
							) : (
								[]
							)
						)}
					</div>
					<div className="see-more-img" onClick={() => showLightBox(0)}>
						<div className="wrap-svg">
							<IcPhotos />
						</div>
						<p>Xem tất cả ảnh</p>
					</div>
				</div>
			</div>
			<Swiper
				className="cover-car-swiper swiper-cover-car"
				slidesPerView={1}
				modules={[Pagination]}
				pagination={{
					el: ".pagi-cover",
					clickable: true,
					dynamicBullets: true,
				}}>
				{covers?.map((cover, i) => (
					<SwiperSlide key={i}>
						<div className="fix-img">
							<img
								loading="lazy"
								src={cover.fullUrl}
								alt={`${isSD ? `Cho thuê xe tự lái ${name}` : `Cho thuê xe du lịch ${name}`}`}
							/>
						</div>
					</SwiperSlide>
				))}
				<div className="swiper-pagination pagi-cover"></div>
			</Swiper>
			{lightBox && (
				<ImageLightBox isOpen={lightBox} photoIndex={photoIndex} images={covers} hideLightBox={hideLightBox} />
			)}
		</div>
	);
};

export default CarDetailCover;
